import { useCallback, useMemo, useRef, useState } from 'react';

import type { Disclosure } from '../_context/DcrFormContext';

export const useDisclosure = (): Disclosure => {
	const [added, setAdded] = useState<readonly string[]>([]);
	const pendingFlash = useRef(new Set<string>());

	const add = useCallback((keys: string | readonly string[]) => {
		const list = typeof keys === 'string' ? [keys] : keys;
		list.forEach(key => pendingFlash.current.add(key));
		setAdded(current => {
			const next = list.filter(key => !current.includes(key));
			return next.length > 0 ? [...current, ...next] : current;
		});
	}, []);

	const takeFlash = useCallback((key: string) => {
		if (!pendingFlash.current.has(key)) return false;
		pendingFlash.current.delete(key);
		return true;
	}, []);

	const isAdded = useCallback((key: string) => added.includes(key), [added]);

	return useMemo(
		() => ({ added, isAdded, add, takeFlash }),
		[added, isAdded, add, takeFlash]
	);
};
